// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/ContactPageBackroundGraphics.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
  background-color: #2f383c;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  padding-left: 60px;
}
.contact-page-container .btn-back.btn.btn-secondary:hover {
  background-color: #272e31 !important;
}
.contact-page-container .page-title {
  color: #00889b;
  font-family: "Open Sans";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}
.contact-page-container .page-title span {
  text-align: center;
}
.contact-page-container .page-subtitle {
  align-items: center;
}
.contact-page-container .page-subtitle span {
  color: #d6e4e9;
  font-family: "Open Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 150%;
  margin: 0 auto;
  text-align: center;
  width: 40%;
}
.contact-page-container .form-label {
  color: #f5fbff;
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
}
.contact-page-container .form-control[type=file] {
  background: transparent;
  border: dashed #595e60 2px;
  height: 40vh;
  text-align: center;
}
.contact-page-container .custom-upload-container {
  align-items: center;
  background: transparent;
  border: dashed #595e60 2px;
  display: flex;
  height: 180px;
  justify-content: center;
  margin: auto;
}
.contact-page-container .custom-upload-container .custom-add-button-container {
  background: transparent;
  border: dashed #595e60 2px;
  border-radius: 8px;
  color: #595e60;
  cursor: pointer;
  display: flex;
  height: 100px;
  justify-content: center;
  margin: auto;
  margin-top: 12px;
  width: 100px;
}

.add-file-container {
  height: 15vh;
  width: 10vh;
}

.file-input-preview-item {
  background-color: red;
  height: 15vh;
  width: 10vh;
}

.footer-btn btn.btn-secondary {
  background-color: #00889b;
  border-radius: 5px;
  color: #ffffff;
}
.footer-btn btn.btn-secondary:hover .footer-btn btn.btn-secondary:active .footer-btn btn.btn-secondary:focus .footer-btn btn.btn-secondary:focus-visible {
  background-color: #00889b;
  color: #ffffff;
}

.custom-modal-header {
  align-items: center;
  background-color: #414b4f;
  display: contents;
  flex-direction: row;
  justify-content: space-between;
}
.custom-modal-header .modal-title {
  display: contents;
}
.custom-modal-header span {
  color: #00889b;
  font-family: "Open Sans";
  font-size: 24px;
  font-weight: bold;
}

.contact-us.btn.btn-secondary {
  background-color: #00889b;
  border-radius: 5px;
  width: 20%;
}

.contact-us-camp {
  height: 100px;
  width: 100%;
}

.preview-image {
  align-items: center;
  display: flex;
  justify-content: center;
}

.preview-close {
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 25px;
  justify-content: center;
  position: absolute;
  right: -22px;
  top: 0;
  transition: 0.8s;
  width: 25px;
}
.preview-close .fa-close {
  color: #f5fbff;
  transition: 0.8s;
}

.preview-close:hover {
  background: #f5fbff;
}
.preview-close:hover .fa-close {
  color: #272e31;
}
.preview-close:hover .page-form .comment-message-length {
  background-color: red;
}`, "",{"version":3,"sources":["webpack://./src/pages/acds-contact/ContactUsPage.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,iFAAA;EAEA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;AAMQ;EACE,oCAAA;AAJV;AAUE;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AARJ;AASI;EACE,kBAAA;AAPN;AAWE;EACE,mBAAA;AATJ;AAUI;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AARN;AAYE;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,uBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AAXJ;AAcE;EACE,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AAZJ;AAaI;EACE,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAXN;;AAgBA;EACE,YAAA;EACA,WAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,YAAA;EACA,WAAA;AAbF;;AAiBE;EACE,yBCvFU;EDwFV,kBAAA;EACA,cAAA;AAdJ;AAeI;EACE,yBC3FQ;ED4FR,cAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AAfF;AAiBE;EACE,iBAAA;AAfJ;AAkBE;EACE,cC7GU;ED8GV,wBAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;;AAoBA;EACE,yBCrHY;EDsHZ,kBAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,gBAAA;EACA,WAAA;AAjBF;AAkBE;EACE,cAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,mBAAA;AAjBF;AAkBE;EACE,cAAA;AAhBJ;AAoBI;EACE,qBAAA;AAlBN","sourcesContent":["@import '../../styles/colors.scss';\n\n.contact-page-container {\n  background: url('../../assets/images/ContactPageBackroundGraphics.svg')\n    no-repeat center center/cover;\n  background-color: #2f383c;\n  background-size: cover;\n  height: 100vh;\n  overflow: hidden;\n  overflow-y: scroll;\n  padding-left: 60px;\n  .btn-back {\n    &.btn {\n      &.btn-secondary {\n        &:hover {\n          background-color: #272e31 !important;\n        }\n      }\n    }\n  }\n\n  .page-title {\n    color: #00889b;\n    font-family: 'Open Sans';\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 150%;\n    span {\n      text-align: center;\n    }\n  }\n\n  .page-subtitle {\n    align-items: center;\n    span {\n      color: #d6e4e9;\n      font-family: 'Open Sans';\n      font-size: 18px;\n      font-style: normal;\n      font-weight: normal;\n      line-height: 150%;\n      margin: 0 auto;\n      text-align: center;\n      width: 40%;\n    }\n  }\n\n  .form-label {\n    color: #f5fbff;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n  }\n\n  .form-control[type='file'] {\n    background: transparent;\n    border: dashed #595e60 2px;\n    height: 40vh;\n    text-align: center;\n  }\n\n  .custom-upload-container {\n    align-items: center;\n    background: transparent;\n    border: dashed #595e60 2px;\n    display: flex;\n    height: 180px;\n    justify-content: center;\n    margin: auto;\n    .custom-add-button-container {\n      background: transparent;\n      border: dashed #595e60 2px;\n      border-radius: 8px;\n      color: #595e60;\n      cursor: pointer;\n      display: flex;\n      height: 100px;\n      justify-content: center;\n      margin: auto;\n      margin-top: 12px;\n      width: 100px;\n    }\n  }\n}\n\n.add-file-container {\n  height: 15vh;\n  width: 10vh;\n}\n\n.file-input-preview-item {\n  background-color: red;\n  height: 15vh;\n  width: 10vh;\n}\n\n.footer-btn {\n  btn.btn-secondary {\n    background-color: $btn-primary;\n    border-radius: 5px;\n    color: #ffffff;\n    &:hover &:active &:focus &:focus-visible {\n      background-color: $btn-primary;\n      color: #ffffff;\n    }\n  }\n}\n\n.custom-modal-header {\n  align-items: center;\n  background-color: #414b4f;\n  display: contents;\n  flex-direction: row;\n  justify-content: space-between;\n\n  .modal-title {\n    display: contents;\n  }\n\n  span {\n    color: $btn-primary;\n    font-family: 'Open Sans';\n    font-size: 24px;\n    font-weight: bold;\n  }\n}\n\n.contact-us.btn.btn-secondary {\n  background-color: $btn-primary;\n  border-radius: 5px;\n  width: 20%;\n}\n\n.contact-us-camp {\n  height: 100px;\n  width: 100%;\n}\n\n.preview-image {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.preview-close {\n  align-items: center;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  height: 25px;\n  justify-content: center;\n  position: absolute;\n  right: -22px;\n  top: 0;\n  transition: .8s;\n  width: 25px;\n  .fa-close {\n    color: #f5fbff;\n    transition: .8s;\n  }\n}\n\n.preview-close:hover {\n  background: #f5fbff;\n  .fa-close {\n    color: #272e31;\n  }\n\n  .page-form {\n    .comment-message-length {\n      background-color: red;\n    }\n  }\n}\n","$site-text: #00171f;\n$safe-list: #8e8e93;\n$trans-white: rgba(255, 255, 255, 0.5);\n$trans-grey: rgba(211, 211, 211, 0.5);\n$disabled-link: rgba(142, 142, 147, 0.15);\n$white: #ffffff;\n$page-background: #f5fbff;\n\n$link: #007ea7;\n$font-awesome-icon-color: #85a3ad;\n\n// Buttons\n$btn-color-white: #ffffff;\n$btn-primary: #00889b;\n$secondary: #9db6be;\n$favorite-star: #f9a825;\n\n// Forms\n$form-control-border: #e7edef;\n$form-color: #85a3ad;\n$form-error: #ef6360;\n\n//text color\n$text-normal: #414b4f;\n\n//primary\n$primary-color: #00889b;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
